import { useTodayExternalCalendarEvents } from 'features/external-connections';
import React from 'react';
import { ExternalEventsList } from 'shared/components/ui/external-events-list';
import { useUser } from 'shared/hooks/use-user';
import { getTimeFormat } from 'shared/utils/get-time-format';

export type ExternalCalendarEventsProps = {
  show: boolean;
};

export const ExternalCalendarEvents: React.FC<ExternalCalendarEventsProps> = ({
  show,
}) => {
  const events = useTodayExternalCalendarEvents();
  const user = useUser();

  if (!events.length) {
    return null;
  }

  return (
    <ExternalEventsList
      events={events}
      show={show}
      timeFormat={getTimeFormat(user)}
    />
  );
};
